import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Box from '@repo/ui/box'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'
import { useFormContext } from 'react-hook-form'

import useTranslate from '../../../../../lib/hooks/use-translate'
import { AffectedStaffQuestionnaireInput } from '../../../../../lib/types/models/affected-staff-questionnaire/affected-staff-questionnaire-input'
import { FormControl, FormField } from '../../../../elements/forms/form'
import ControlledRadioInput from '../../../../elements/inputs/controlled-radio-input'

const StaffPersonalSpaceQuestionnaireDriverLicense = () => {
  const { t } = useTranslate()
  const form = useFormContext<AffectedStaffQuestionnaireInput>()
  return (
    <InnerBox
      title={t('affected.staff.questionnaire.driver.license.title')}
      className="p-4 rounded-lg "
    >
      <div className="flex flex-col gap-3 ">
        <div className="flex gap-5 items-center mobile:flex-col mobile:gap-2 mobile:items-start">
          <Typography variant="tag" color={tailwindColors.grey.DEFAULT}>
            {t('affected.staff.questionnaire.driver.license.do.you.have.driver.license')}
          </Typography>
          <div className="flex items-center gap-4">
            <FormField
              control={form.control}
              name={'hasDriversLicense'}
              render={({ field }) => (
                <FormControl>
                  <ControlledRadioInput
                    {...field}
                    label={t('staff.personal.space.yes')}
                    checked={field.value === true}
                    onCheck={() =>
                      form.setValue('hasDriversLicense', true, { shouldValidate: true })
                    }
                  />
                </FormControl>
              )}
            />
            <FormField
              control={form.control}
              name={'hasDriversLicense'}
              render={({ field }) => (
                <FormControl>
                  <ControlledRadioInput
                    {...field}
                    label={t('staff.personal.space.no')}
                    checked={field.value === false}
                    onCheck={() => {
                      form.setValue('hasDriversLicense', false, { shouldValidate: true })
                      form.setValue('drivesRegularly', undefined, { shouldValidate: true })
                    }}
                  />
                </FormControl>
              )}
            />
          </div>
        </div>
        {form.watch('hasDriversLicense') && (
          <InnerBox className="bg-white-hover p-2 w-fit flex flex-row items-center gap-3">
            <Typography variant="label-medium" color={tailwindColors.grey.DEFAULT}>
              {t('affected.staff.questionnaire.driver.license.do.you.drive.regularly')}
            </Typography>
            <div className="flex gap-3 items-center">
              <FormField
                control={form.control}
                name={'drivesRegularly'}
                render={({ field }) => (
                  <FormControl>
                    <ControlledRadioInput
                      {...field}
                      label={t('staff.personal.space.yes')}
                      checked={field.value === true}
                      onCheck={() =>
                        form.setValue('drivesRegularly', true, { shouldValidate: true })
                      }
                    />
                  </FormControl>
                )}
              />
              <FormField
                control={form.control}
                name={'drivesRegularly'}
                render={({ field }) => (
                  <FormControl>
                    <ControlledRadioInput
                      {...field}
                      label={t('staff.personal.space.no')}
                      checked={field.value === false}
                      onCheck={() =>
                        form.setValue('drivesRegularly', false, { shouldValidate: true })
                      }
                    />
                  </FormControl>
                )}
              />
            </div>
          </InnerBox>
        )}

        <Box className="bg-primary-light rounded p-3">
          <Typography variant="label-semibold" color={tailwindColors.primary.DEFAULT}>
            {t('affected.staff.questionnaire.driver.license.note')}
          </Typography>
        </Box>
      </div>
    </InnerBox>
  )
}

export default StaffPersonalSpaceQuestionnaireDriverLicense
